import React from 'react'
import { eventCategories } from 'components/Simulation/constants'
import PropTypes from 'prop-types'

import { useTranslation } from 'react-i18next'
import InfoBox from 'components/Shared/InfoBox'

function Switcher(props) {
  const { selectedOption, setSelectedOption, onCategoryChanged, isPublished, specialAdCategory = '' } = props

  const { t, i18n } = useTranslation()

  const options = [
    {
      key: 'default',
      label: t('Simulation.tabTitles.default'),
      index: 0,
    },
    {
      key: 'event',
      label: t('Simulation.tabTitles.event'),
      index: 1,
    },
    {
      key: 'special',
      label: t('Simulation.tabTitles.special'),
      index: 2,
    }
  ]

  const isLastOption = (option) => option.index === options.length - 1
  const isFirstOption = (option) => option.index === 0

  const handleTabChange = (key) => {
    if (key === 'default') {
      onCategoryChanged('product')
    } else if (key === 'event') {
      onCategoryChanged(eventCategories[0].value)
    } else if (key === 'special') {
      onCategoryChanged('product')
    }
    setSelectedOption(key)
  }

  const isPublishedSpecialAd = isPublished && !!specialAdCategory
  const disableSpecialAd = (key) => isPublished && key === 'special' && !specialAdCategory

  return (
    
    <InfoBox
      title={t('Tips.Simulation.categories.title')}
      body={
        <div className="d-flex flex-column gap-2">
          <span>{t('Tips.Simulation.categories.body1')}</span>
        
          <span>{t('Tips.Simulation.categories.body2')}</span>
        </div>
      }
      placement="bottom"
    >
      <InfoBox
        body={t('Tips.EventEdit.disableCategoryChangeTooltip.body')}
        enabled={isPublishedSpecialAd && !disableSpecialAd('special')}
        withAnchor={false}
        placement="bottom"
        classNames="d-inline-block"
      >
        <div className={`simulation-form_switcher ${isPublishedSpecialAd ? 'simulation-form_switcher--disabled' : ''}`}>
          {options.map((option) => (
            <InfoBox 
              key={option.key}
              body={t('Tips.EventEdit.specialAdCategoryTooltip.body')}
              enabled={disableSpecialAd(option.key) && !isPublishedSpecialAd}
              withAnchor={false}
              placement="bottom"
            >
              <button
                key={option.key}
                type="button"
                onClick={() => handleTabChange(option.key)}
                disabled={disableSpecialAd(option.key)}
                className={`
            simulation-form_switcher_button
            ${selectedOption === option.key ? 'simulation-form_switcher_button--active' : ''}
            ${isLastOption(option) ? 'simulation-form_switcher_button--last' : ''}
            ${isFirstOption(option) ? 'simulation-form_switcher_button--first' : ''}
            ${disableSpecialAd(option.key) ? 'simulation-form_switcher_button--disabled' : ''}
            ${i18n.language === 'de' ? 'simulation-form_switcher_button--de' : ''}
            `}
              >
                {option.label}
              </button>
            </InfoBox>
          ))}
        </div>
      </InfoBox>
    </InfoBox>
  )
}

export default Switcher

Switcher.propTypes = {
  selectedOption: PropTypes.string.isRequired,
  setSelectedOption: PropTypes.func.isRequired,
  onCategoryChanged: PropTypes.func.isRequired,
}